var _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpinner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "rgba(255, 255, 255, 0)",
      display: "block"
    },
    width: "200px",
    height: "200px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 25L80 25L80 75L20 75Z",
    fill: "#ffffff",
    stroke: "#000000",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 25L80 25L80 75L50 75",
    fill: "#ffffff",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0s",
    keyTimes: "0;0.5;0.501;1",
    values: "M50 25L80 25L80 75L50 75;M50 25L50 20L50 80L50 75;M50 25L80 25L80 75L50 75;M50 25L80 25L80 75L50 75"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0s",
    keyTimes: "0;0.5;0.5001;1",
    values: "1;1;0;0"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 25L80 25L80 75L50 75",
    fill: "#ffffff",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.166s",
    keyTimes: "0;0.5;0.501;1",
    values: "M50 25L80 25L80 75L50 75;M50 25L50 20L50 80L50 75;M50 25L80 25L80 75L50 75;M50 25L80 25L80 75L50 75"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.166s",
    keyTimes: "0;0.5;0.5001;1",
    values: "1;1;0;0"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50 25L80 25L80 75L50 75",
    fill: "#ffffff",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.33s",
    keyTimes: "0;0.5;0.501;1",
    values: "M50 25L80 25L80 75L50 75;M50 25L50 20L50 80L50 75;M50 25L80 25L80 75L50 75;M50 25L80 25L80 75L50 75"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.33s",
    keyTimes: "0;0.5;0.5001;1",
    values: "1;1;0;0"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50 25L80 25L80 75L50 75",
    fill: "#ffffff",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.33s",
    keyTimes: "0;0.499;0.5;1",
    values: "M50 25L20 25L20 75L50 75;M50 25L20 25L20 75L50 75;M50 25L50 20L50 80L50 75;M50 25L20 25L20 75L50 75"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.33s",
    keyTimes: "0;0.4999;0.5;1",
    values: "0;0;1;1"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50 25L80 25L80 75L50 75",
    fill: "#ffffff",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.166s",
    keyTimes: "0;0.499;0.5;1",
    values: "M50 25L20 25L20 75L50 75;M50 25L20 25L20 75L50 75;M50 25L50 20L50 80L50 75;M50 25L20 25L20 75L50 75"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "-0.166s",
    keyTimes: "0;0.4999;0.5;1",
    values: "0;0;1;1"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50 25L80 25L80 75L50 75",
    fill: "#ffffff",
    stroke: "#000000",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "d",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0s",
    keyTimes: "0;0.499;0.5;1",
    values: "M50 25L20 25L20 75L50 75;M50 25L20 25L20 75L50 75;M50 25L50 20L50 80L50 75;M50 25L20 25L20 75L50 75"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    dur: "1s",
    repeatCount: "indefinite",
    begin: "0s",
    keyTimes: "0;0.4999;0.5;1",
    values: "0;0;1;1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/spinner.2871b3fb.svg";
export { ForwardRef as ReactComponent };